import { combineReducers } from "redux";
import { jarvisPrimeDashboardReducers } from "./jarvisPrimeDashboard/jarvisPrimeDashboardReducers";

import { jarvisPrimeOnboardingReducer } from "./jarvisPrimeOnboarding/jarvisPrimeOnboardingReducer";
import { jarvisPrimeExistingHoldingReducer } from "./jarvisPrimeExistingHolding/jarvisPrimeExistingHoldingReducer";
import { jarvisPrimeTransactionReducers } from "./jarvisPrimeTransaction/jarvisPrimeTransactionReducers";
import { jarvisPrimeInvestMoreReducers } from "./jarvisPrimeInvestMore/jarvisPrimeInvestMoreReducers";
import { jarvisPrimeRmsReducers } from "./jarvisPrimeRms/jarvisPrimeRmsReducers";
import { primeHoldingReducers } from "stores/jarvisPrime/primeHolding/primeHoldingReducers";
import { jarvisPrimeActionCenterReducers } from "./jarvisPrimeActionCenter/jarvisPrimeActionCenterReducers";


const jarvisPrimeRootReducer = combineReducers({
  primeOnboarding: jarvisPrimeOnboardingReducer,
  primeExistingHolding: jarvisPrimeExistingHoldingReducer,
  primeTransaction: jarvisPrimeTransactionReducers,
  primeDashboard: jarvisPrimeDashboardReducers,
  PrimeInvestMore: jarvisPrimeInvestMoreReducers,
  primeRMS: jarvisPrimeRmsReducers,
  primeHolding: primeHoldingReducers,
  PrimeActionCentre : jarvisPrimeActionCenterReducers,

  
});

export { jarvisPrimeRootReducer };
